import { Avatar, Flex } from "antd";
import styled from "styled-components";

export const StyledProfileMenuCard = styled(Flex)`
  width: 100%;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 12px;
  cursor: pointer;
`;

export const StyledProfileMenuAvatar = styled(Avatar)`
  svg {
    fill: ${({ theme }) => theme.palette.background.paper};
  }
`;

export const StyledProfileMenuUserInfo = styled(Flex)`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.xxl}px) {
    max-width: 280px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    max-width: 260px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    max-width: 280px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
    max-width: none;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.xs}px) {
    max-width: 260px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.xxs}px) {
    max-width: 200px;
  }
`;

export const StyledProfileMenuUserCard = styled(Flex)`
  background-color: ${({ theme }) => theme.palette.background.paper};
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  .ant-skeleton {
    width: -webkit-fill-available !important;
  }
  .ant-skeleton-paragraph {
    margin-bottom: 0px !important;
    margin-block-start: 16px !important;
    li + li {
      margin-block-start: 8px !important;
    }
  }
`;
